/**
 * Class used to represent a specific level of detail of a mesh
 * @see http://doc.babylonjs.com/how_to/how_to_use_lod
 */
var MeshLODLevel =
/** @class */
function () {
  /**
   * Creates a new LOD level
   * @param distance defines the distance where this level should star being displayed
   * @param mesh defines the mesh to use to render this level
   */
  function MeshLODLevel(
  /** Defines the distance where this level should start being displayed */
  distance,
  /** Defines the mesh to use to render this level */
  mesh) {
    this.distance = distance;
    this.mesh = mesh;
  }

  return MeshLODLevel;
}();

export { MeshLODLevel };